<p>clam-edit-item-details works!</p>
